import * as React from 'react';
import { connect } from 'react-redux';
import defaultImage from 'src/assets/defaultImage';
import './ProductCard.scss';
import AddToListMenu from '../AddToListMenu';
import ProductModel from 'src/model/product.model';
import { partDetailUrl } from 'src/utils/navigation';
import i18n from 'src/translation/i18n';

export interface IProductCardProps {
  part: ProductModel;
  showOnlyMSRP: boolean;
  isLoggedIn: boolean;
  id: string;
  name: string;
  category: string;
  mfc: string;
  description: string;
  price: number;
  msrp: number;
  image: string;
  state?: string;
  stateDescription?: string;
  inStock?: boolean;
  isFavoriteLoading?: boolean;
  selectedFavoriteItem?: string;
  favorite?: boolean;
  favoriteId?: number;
  deal?: boolean;
  section?: boolean;
  brand?: string;
  viewDetails?: string;
  handleOnClicBuyNow(productId: string): void;
  handleToggleFavorite?(
    name: string,
    category:string,
    mfc: string,
    favorite: boolean,
    favoriteId: number
  ): void;
  reloadPart?: () => void;
  t?: any;
}

class ProductCard extends React.Component<IProductCardProps, any> {
  /* 
    getStatus
   */
  private getStatus = (): {
    available: boolean;
    notLongerAvailable: boolean;
  } => {
    const { part } = this.props;
    const availableFlag = {
      available: false,
      notLongerAvailable: false
    };

    if (part.available) {
      availableFlag.available = true;

      if (
        part.partnerPrice === 0 ||
        (part.partnerPrice === 0.0 && part.retailPrice === 0) ||
        part.partnerPrice === 0.0
      ) {
        availableFlag.notLongerAvailable = false;
      }
    } else {
      availableFlag.available = false;
    }

    return availableFlag;
  };

  private renderStatus() {
    const availableFlag = this.getStatus();

    if (this.props.isLoggedIn) {
      if (availableFlag.notLongerAvailable) {
        return (
          <div className="rp-product-card--status">
            <span className="rp-product-card--status-container">
              <i className="rpds rpds-remove-circle" />
              <span>{i18n.t('common.noLongerAvailable')}</span>
            </span>
          </div>
        );
      } else {
        if (availableFlag.available) {
          return (
            <div className="rp-product-card--status">
              {this.props.inStock !== null &&
                (this.props.inStock ? (
                  <span className="rp-product-card--status-container">
                    <i
                      title={
                        this.props.stateDescription
                          ? this.props.stateDescription
                          : ''
                      }
                      className="rpds rpds-check-circle"
                    />
                    <span
                      title={
                        this.props.stateDescription
                          ? this.props.stateDescription
                          : ''
                      }
                    >
                      {/* {this.props.state} */}
                      {this.getStockStatus(this.props.state)}
                    </span>
                  </span>
                ) : (
                  <span className="rp-product-card--status-container">
                    <i
                      title={
                        this.props.stateDescription
                          ? this.props.stateDescription
                          : ''
                      }
                      className="rpds rpds-remove-circle"
                    />
                    <span
                      title={
                        this.props.stateDescription
                          ? this.props.stateDescription
                          : ''
                      }
                    >
                      {/* {this.props.state} */}
                      {this.getStockStatus(this.props.state)}
                    </span>
                  </span>
                ))}
              {this.props.part.specialOrder && (
                <span className="rp-product-card--status-container">
                  <i
                    title={'Special Order'}
                    className="rpds rpds-new-releases"
                  />
                  <span title={'Special Order'}>
                    {i18n.t('common.specialOrder')}
                  </span>
                </span>
              )}
            </div>
          );
        } else {
          return (
            <span className="rp-product-card--status-container">
              <i className="rpds rpds-remove-circle" />
              <span>{i18n.t('common.notAvailable')}</span>
            </span>
          );
        }
      }
    } else {
      return <React.Fragment />;
    }
  }

  /* 
    getPrices
   */
  private getPrices = () => {
    const availableFlag = this.getStatus();
    // this.props.price !== 0 && this.props.msrp !== 0 ? true : false;

    if (availableFlag.notLongerAvailable) {
      return <div className="rp-product-card--info-login empty-prices" />;
    } else {
      return this.props.isLoggedIn ? (
        <div className="rp-product-card--info-prices">
          <React.Fragment>
            <div className="rp-product-card--info-price">
              <span className="rp-product-card--label">
                {(i18n.t('common.msrp') as string).toUpperCase()}
              </span>
              <p>${Number(this.props.msrp).toFixed(2)}</p>
            </div>
            {!this.props.showOnlyMSRP && (
              <div className="rp-product-card--info-price">
                <span className="rp-product-card--label">
                  {i18n.t('myOrders.price')}
                </span>
                <p className="rp-card-price-info-value">
                  ${Number(this.props.price).toFixed(2)}
                </p>
              </div>
            )}
          </React.Fragment>
        </div>
      ) : (
        <div className="rp-product-card--info-login">
          {i18n.t('common.loginToViewPrices')}
        </div>
      );
    }
  };

  /* 
    getButtons
   */
  private getButtons = () => {
    const availableFlag = this.getStatus();
    let lng = 'en';
    const language = i18n.language;
    lng = language.split('-')[0];
    // this.props.price !== 0 && this.props.msrp !== 0 ? true : false;

    if (!availableFlag.available || availableFlag.notLongerAvailable) {
      return <div className="rp-product-card--empty-buttons" />;
    } else {
      return (
        <React.Fragment>
          <span
            className={
              lng === 'en'
                ? 'add-list-button'
                : 'add-list-button font-shrik-add-list'
            }
          >
            <AddToListMenu
              direction="top"
              label={i18n.t('common.addToList')}
              height="36px"
              width="90px"
              part={this.props.part}
              category={this.props.category}
              mfc={this.props.mfc}
              favorite={this.props.favorite}
              reloadOrigin={this.props.reloadPart}
            />
          </span>
          <button
            className={
              lng === 'en'
                ? 'primary-button buy-button'
                : 'primary-button buy-button font-shrik-add-list'
            }
            onClick={() => {
              this.props.section
                ? this.props.handleOnClicBuyNow(this.props.viewDetails)
                : this.props.handleOnClicBuyNow(
                    `${this.props.mfc}  ${this.props.name}`
                  );
            }}
          >
            {i18n.t('common.buyNow')}
          </button>
        </React.Fragment>
      );
    }
  };

  public shouldComponentUpdate() {
    return true;
  }

  public render() {
    return (
      <div
        className={
          this.props?.isLoggedIn
            ? 'rp-product-card roboto ' + (this.props.section && 'flyersCard')
            : 'rp-product-card roboto rp-non-login-container'
        }
      >
        {this.props.isLoggedIn &&
          (this.props.favorite ? (
            <span role="button" tabIndex={0}
            onKeyDown ={e =>   	
              this.props.handleToggleFavorite(    
                this.props.name,  
                this.props.category,  
                this.props.mfc,    
                this.props.favorite,    
                this.props.favoriteId    
              )    
            }
              className="starstyles star rpds rpds-star yellow"
              onClick={e =>
                this.props.handleToggleFavorite(
                  this.props.name,
                  this.props.category,
                  this.props.mfc,
                  this.props.favorite,
                  this.props.favoriteId
                )
              }
            />
          ) : (
            <span role="button" tabIndex={0}
            onKeyDown={e =>   	
              this.props.handleToggleFavorite(    
                this.props.name, 
                this.props.category,   
                this.props.mfc,    
                this.props.favorite,    
                this.props.favoriteId    
              )    
            }
              className="starstyles star rpds rpds-star-border"
              onClick={e =>
                this.props.handleToggleFavorite(
                  this.props.name,
                  this.props.category,
                  this.props.mfc,
                  this.props.favorite,
                  this.props.favoriteId
                )
              }
            />
            
          ))}
        {this.props.brand ? (
          <span className="brand-placeholder">
            <img
              className="brand-logo"
              src={this.props.brand}
              alt="brand-logo"
            />
          </span>
        ) : null}
        {this.props.isFavoriteLoading && this.props.selectedFavoriteItem === this.props.name && <div className='spinner'/>}

        <div className="differentCards">
          <div className="rp-product-card--top">
            {this.props.deal && !this.props.section ? (
              <span className="rp-product-card--deal">
                {i18n.t('common.onSale')}
              </span>
            ) : null}
            {/* <span className="rp-product-card--deal">
              {i18n.t('common.onSale')}
            </span> */}
            <div role="image" aria-label={"Featured Part "+this.props.id}
              className={
                'image-container ' + (this.props.section && 'flyers-image')
              }
              style={{
                backgroundImage: `url(${
                  this.props.image !== '' ? 
                  this.props.image === 'undefined' ? defaultImage :
                  this.props.image : defaultImage
                })`
              }}
              onClick={() => {
                this.props.section
                  ? this.props.handleOnClicBuyNow(this.props.viewDetails)
                  : this.props.handleOnClicBuyNow(
                      `${this.props.mfc}  ${this.props.name}`
                    );
              }}
            />
          </div>
          <div className="rp-product-card-pricing-and-buttons">
            <div className="rp-product-card--info">
              <div className="rp-product-info-alignment">
                <div className="rp-product-card--info-name">
                  <a
                    className="rp-product-card--info-name-link"
                    href={
                      this.props.isLoggedIn &&
                      partDetailUrl(`${this.props.mfc}  ${this.props.name}`)
                    }
                    onClick={() => {
                      this.props.section
                        ? this.props.handleOnClicBuyNow(this.props.viewDetails)
                        : this.props.handleOnClicBuyNow(
                            `${this.props.mfc}  ${this.props.name}`
                          );
                    }}
                  >
                    {this.props.name}
                  </a>
                </div>
                <div className="rp-product-status-alignment">
                  {this.renderStatus()}
                </div>
              </div>

              <div className="rp-product-card--info-description">
                {this.props.description}
              </div>
              {this.getPrices()}
            </div>
            <div className="rp-product-card--down">{this.getButtons()}</div>
          </div>
        </div>
      </div>
    );
  }

  public getStockStatus(state: string): string {
    if (!state) {
      return state;
    }
    switch (state.toLowerCase()) {
      case 'in stock':
        return i18n.t('common.inStock');
      case 'out of stock':
        return i18n.t('common.outOfStock');
      case 'no longer available':
        return i18n.t('common.noLongerAvailable');
        break;
      case 'backorder':
        return i18n.t('myOrders.backOrder');
        break;
      case 'special order':
        return i18n.t('common.specialOrder');
        break;
      default:
        return state;
    }
  }
}

interface IStateFromProps {
  showOnlyMSRP: boolean;
  isLoggedIn: boolean;
}

const mapStateToProps = (state: any) => ({
  showOnlyMSRP: state.msrp.showOnlyMSRP,
  isLoggedIn: state.signin.success
});

export default connect<IStateFromProps, any, void>(mapStateToProps)(
  ProductCard
);
